import { Wrapper } from './styles';

const PreviewMode: React.FC = () => (
  <Wrapper>
    <span>Você está em modo preview.</span>
    <br />
    <span>Neste modo você pode ver somente rascunhos ou revisões.</span>
    <br />
    <a href="/api/exit-preview">Clique aqui </a>
    para sair do modo preview
  </Wrapper>
);

export default PreviewMode;
